import { Format } from 'ui/atoms/UploadFile/types'

export const formats: Format[] = ['pdf', 'jpg', 'jpeg', 'png']
